export const codeFromFullCode = fullCode =>
  fullCode.slice(0, fullCode.indexOf('_')).toUpperCase();
